//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
export default {
  name: 'privacy_policy',
  head() {
      return {
          title:this.meta_title,
          bodyAttrs: {
                class: 'w-store static-pages'
            },
          meta: [
          {   hid: 'description',
              name: 'description',
              content: this.meta_description
          },
            {
        hid: 'og:title',
        property: 'og:title',
        content:this.meta_title
        },
        {
        hid:'og:url',
        property:'og:url',
        content:this.$store.state.list.base_Url+this.$route.path},
        {
        hid:'og:image',
        property:'og:image',
        content:'https://walkwayshoes.com/images-walk/logo.png'},
        {
        hid:'og:image-width',
        property:'og:image-width',
        content:'200' 
        },
        {hid:'og:image-height',content:'200'},
        {
        name:'og:description',
        content:this.meta_description
        },
        {
          name:'twitter:site',
          content:'@Walkway'
        },
        {
          name:'twitter:title',
          content:this.meta_title
        },
       {
          name:'twitter:description',
          content:this.meta_description
        },
         {
          name:'twitter:image',
          content:'https://walkwayshoes.com/images-walk/logo.png'
        },
        {
          name:'twitter:app:country',
          content:'IN'
        },
        {
          name:'twitter:app:name:iphone',
          content:'Walkway'
        },
          {
          name:'twitter:app:url:iphone',
          content:this.$store.state.list.base_Url+this.$route.path
        },
       {
          name:'twitter:app:name:googleplay',
          content:'Walkway',
        },
        {
          name:'twitter:app:url:googleplay',
          content:this.$store.state.list.base_Url+this.$route.path,
        },
        {
          name:'twitter:app:id:googleplay',
          content:'com.walkway.android'
        },
          {
              property: 'keywords',
              content: this.meta_keyword
          }
          ],
            // link:[
            //     {
            //         rel:"canonical",
            //         href:this.$store.state.list.currentHost+this.$route.fullPath
            //     },
                
            // ]
      }
  },
//   metaInfo () {
//       return {
//           title:this.meta_title,
//           bodyAttrs: {
//                 class: 'w-store static-pages'
//             },
//           meta: [
//           {   hid: 'description',
//               name: 'description',
//               content: this.meta_description
//           },
//           {
//               property: 'keywords',
//               content: this.meta_keyword
//           }
//           ],
//             link:[
//                 {
//                     rel:"canonical",
//                     href:"https://"+location.host+this.$route.fullPath
//                 }
//             ]
//       }
//   },
  data() {
        return {
            meta_title:'',
            meta_description:'',
            meta_keyword:'',
            content:'',
            url_key:this.$route.params.index
        };
    },
    
     updated(){
            jQuery('.faq_item_h4').click(function(){
                //  event.stopImmediatePropagation();
                jQuery(this).siblings('.faq_item_p').toggle();
            });
            jQuery('body').on('click', '.faqheaderitem a', function(){
                var faqtab = jQuery(this).attr('data-id');
                jQuery('html, body').animate({scrollTop:jQuery('#'+faqtab).position().top-20 + 20}, 'slow');
                jQuery('.faqheaderitem').removeClass('active');
                jQuery(this).parents('.faqheaderitem').addClass('active');
            });
            if ( document.location.href.indexOf('#return_exchange') > -1 ) {
                setTimeout(function(){
                    jQuery('html, body').animate({scrollTop:jQuery('#return_exchange').position().top + 20}, 'slow');
                }, 500);
            }if ( document.location.href.indexOf('#payments') > -1 ) {
                setTimeout(function(){
                    jQuery('html, body').animate({scrollTop:jQuery('#payments').position().top + 20}, 'slow');
                }, 500);
            }if ( document.location.href.indexOf('#placing-order') > -1 ) {
                setTimeout(function(){
                    jQuery('html, body').animate({scrollTop:jQuery('#placing-order').position().top + 20}, 'slow');
                }, 500);
            }

            

            jQuery.fn.isInViewport = function() {
            var elementTop = jQuery(this).offset().top;
            var elementBottom = elementTop + jQuery(this).outerHeight();

            var viewportTop = jQuery(window).scrollTop();
            var viewportBottom = viewportTop + 150;

            return elementBottom > viewportTop && elementTop < viewportBottom;
            };

            jQuery(window).on('resize scroll', function() {
            jQuery('.faq_item_con').each(function() {
                var activeColor = jQuery(this).attr('id');
                if (jQuery(this).isInViewport()) {
                    jQuery('.faqheaderitem').removeClass('active');
                    jQuery('.faqheaderitem a[data-id="'+activeColor+'"]').parents('.faqheaderitem').addClass('active');
                }
            });
            });
     },
   async fetch() {
       if(this.url_key.indexOf('.html') != -1) {
            this.url_key = this.url_key.split('.')[0]
        }
        this.$store.state.list.page_loader = true;
        await axios.get(this.$store.state.list.api_url+`/pim/pimresponse.php/?service=cms_page&url_key=${this.url_key}&store=1`)
        .then(response => {
            this.$store.state.list.breadcrumb = response.data.result[0].name;
            this.$store.state.list.page_loader = false;
            this.content=response.data.result[0].content;
            this.meta_title = response.data.result[0].meta_title;
            this.meta_description = response.data.result[0].meta_description;
            this.$store.state.list.footerSeo = response.data.result[0].footer_content;
            this.meta_keyword = '';
        })
   },
   mounted(){
       $("#searchIcon1").click(function () {
        $("#searchBox2").toggleClass("toggleSearch");
        // $("#searchBox2").addClass("d-none");
        });
       window.scrollTo(0, 0);
   }
}
